<template>
    <div id="appss">
        <div class="h1">
            <img src="../../assets/img/mOfficial/banner.png" alt="">
        </div>
        <div class="h2">

            <van-tabs title-active-color="rgba(231, 20, 26, 1)" v-model="active" sticky>
                <van-tab title="股多多介绍">
                    <div class="h2_1">
                        <div class="li-1">
                            <div class="w">
                                <div class="imgss">
                                    <!-- 视频位置 -->
                                    <img src="../../assets/img/mOfficial/h1-1.png" alt="">
                                </div>

                            </div>
                        </div>
                        <div class="li-2">
                            <div class="w">
                                <div class="lis1">
                                    <img src="../../assets/img/mOfficial/h1-2.png" alt="">
                                    <p>专业、正规、老牌，我们是“天相人”！</p>
                                </div>
                                <div class="lis2">
                                    北京天相财富管理顾问有限公司（简称“天相财富”）是天相投资顾问有限公司的全资子公司，2015年10月26日成立，<span>具有中国证监会核准的证券投资咨询业务资格（业务许可证编号：91110102MA001GJE1N）。</span>
                                </div>
                                <div class="lis3" style="margin: .3rem 0;">
                                    公司主营业务包括证券投资研究、证券投资顾问、软件开发与服务等。经过多年的发展，公司为个人证券投资者提供<span>基于数据化、模型化、智能化的证券投资辅助决策工具、量化策略软件及投资者教育产品和服务。</span>
                                </div>
                                <div class="lis4" style="margin-bottom: .3rem;">
                                    股多多产品是北京天相财富管理顾问有限公司（简称“天相财富”）具有全部知识产权的面向广大投资者的证券投资辅助决策工具软件。</div>
                                <div class="lis4">股多多专注龙头股策略，致力提升中小投资者专业水平，解决散户炒股痛点，打造具有核心竞争力的操盘辅助决策工具。</div>
                            </div>
                        </div>
                        <div class="heng"></div>
                        <div class="li-3">
                            <div class="w">
                                <div class="lis1">
                                    <img src="../../assets/img/mOfficial/h1-2.png" alt="">
                                    <div class="r">
                                        <div class="p1">高度同质化中谋寻出路</div>
                                        <div class="p2">天相财富股多多脱颖而出</div>
                                    </div>
                                </div>
                                <div class="lis2">
                                    股多多智能辅助决策炒股工具，具有深厚的行业背景和资源；以及专业的互联网、金融领域技术团队。
                                </div>
                                <div class="lis3" style="margin: .3rem 0;">
                                    运用智能算法穿透投资行为，并采用智能分析工具辅助人工完成决策的工作，<span>最终实现投资组合的自动优化，高效的为客户提供龙头股辅助决策建议。</span>
                                </div>
                                <div class="lis4" style="margin-bottom: .3rem;">
                                    正是基于对国内金融市场深刻洞察，以及千篇一律的投顾功能在目前中国市场所面临困境的研判，尤其是二级市场波动大、客户不理性、风险意识低、资产证券化水平低等现状，股多多软件并没有照搬市场内普遍智能投顾产品，而是做了针对性、系统性的调整优化专注于龙头股研究、龙头股决策效率、擒龙方案规划、需求与服务匹配。
                                </div>
                                <div class="lis5">
                                    体现在软件中，我们不断对自有擒龙体系进行优化，辅助客户让龙头股的操作落到实处。
                                </div>
                            </div>
                        </div>
                    </div>
                </van-tab>
                <van-tab title="资质证书">
                    <div class="h2_2">
                        <div class="w">
                            <img class="img1" src="../../assets/img/mOfficial/h2-1.png" alt="">
                            <img class="img2" src="../../assets/img/mOfficial/h2-2.png" alt="">
                            <img class="img3" src="../../assets/img/mOfficial/h2-3.png" alt="">
                        </div>
                    </div>
                </van-tab>
                <van-tab title="风险揭示">
                    <div class="h2_3">
                        <img src="../../assets/img/mOfficial/1.png" alt="">
                        <img src="../../assets/img/mOfficial/2.png" alt="">
                        <img src="../../assets/img/mOfficial/3.png" alt="">
                        <img src="../../assets/img/mOfficial/4.png" alt="">
                        <img src="../../assets/img/mOfficial/5.png" alt="">
                        <img src="../../assets/img/mOfficial/6.png" alt="">
                        <img src="../../assets/img/mOfficial/7.png" alt="">
                        <img src="../../assets/img/mOfficial/9.png" alt="">
                        <img src="../../assets/img/mOfficial/10.png" alt="">
                        <img src="../../assets/img/mOfficial/11.png" alt="">
                        <img src="../../assets/img/mOfficial/12.png" alt="">
                        <img src="../../assets/img/mOfficial/13.png" alt="">
                        <img src="../../assets/img/mOfficial/14.png" alt="">
                        <img src="../../assets/img/mOfficial/15.png" alt="">
                    </div>
                </van-tab>
                <van-tab title="联系我们">
                    <div class="h2_4">
                        <div class="lis1">
                            <div class="w"> n
                                <img src="../../assets/img/mOfficial/h4-1.png" alt="">
                                <div class="text" style="text-indent:.52rem">
                                    股多多产品是北京天相财富管理顾问有限公司（简称“天相财富”）具有全部知识产权的面向广大投资者的证券投资辅助决策工具软件。天相财富是天相投资顾问有限公司的全资子公司，2015年10月26日成立，具有中国证监会核准的证券投资咨询业务资格（业务许可证编号：91110102MA0O1GJEIN）。天相财富秉承金融科技为基、投研能力为本，不断保持投研实力的专业性和产品创新的先发优势，打造出专注龙头股交易的智能决策炒股软件
                                    -<span>股多多</span>
                                </div>
                            </div>
                        </div>
                        <div class="lis2">
                            <div class="w">
                                <div class="text1">北京天相财富管理顾问有限公司</div>
                                <div class="text2">
                                    <img class="img1" src="../../assets/img/mOfficial/h4-2.png" alt="">
                                    <div class="text">邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：shouhou@txsec.com
                                    </div>
                                </div>
                                <div class="text2">
                                    <img class="img1" src="../../assets/img/mOfficial/h4-3.png" alt="">
                                    <div class="text">客服电话：010-66045051</div>
                                    <img class="img2" src="../../assets/img/mOfficial/h4-7.png" alt="">

                                </div>
                                <div class="text2">
                                    <img class="img1" src="../../assets/img/mOfficial/h4-4.png" alt="">
                                    <div class="text">申诉电话：400-101-8662</div>
                                    <img class="img2" src="../../assets/img/mOfficial/h4-7.png" alt="">
                                </div>
                                <div class="text2">
                                    <img class="img1" src="../../assets/img/mOfficial/h4-5.png" alt="">
                                    <div class="text">公司网址：https://www.txcfgl.com</div>
                                </div>
                                <div class="text2">
                                    <img class="img1" src="../../assets/img/mOfficial/h4-4.png" alt="">
                                    <div class="text">公司地址：北京市丰台区汉威国际广场3区5-10M</div>
                                </div>

                            </div>
                        </div>
                        <div class="heng"></div>
                        <div class="lis3">
                            <img src="../../assets/img/mOfficial/qr.png" alt="">
                            <span>官方服务号：天相股多多</span>
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
        </div>

    </div>
</template>
<script>
import Vue from 'vue';
import { Tab, Tabs } from 'vant';

Vue.use(Tab);
Vue.use(Tabs);
export default {
    data() {
        return {
            active: 0,
        };
    },
    mounted() { },
    methods: {

    }
};
</script>
<style lang="less" scoped>
#appss {
    overflow: hidden;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;


    .heng {
        width: 7.5rem;
        height: .01rem;
        background-color: rgba(238, 238, 238, 1);
        margin-top: .5rem;
    }

    .h1 {
        // width: 7.5rem;
        // height: 4.96rem;


        img {
            width: 7.5rem;
            height: 4.96rem;
        }
    }

    .w {
        width: 6.86rem;
        margin: 0 auto;
    }

    .h2 {
        width: 100%;


        .van-tabs__wrap .van-tab--active {
            color: red !important;
            font-weight: 600 !important;
        }

        .h2_1 {

            .li-1 {
                width: 100%;
                height: 4.39rem;
                background-color: rgba(240, 240, 240, 1);

                .imgss {
                    padding-top: .25rem;

                    img {
                        width: 6.86rem;
                        height: 3.84rem;
                    }
                }

            }

            .li-2 {
                width: 100%;
                background-color: #fff;

                .lis1 {
                    font-size: .34rem;
                    color: rgba(231, 20, 26, 1);
                    font-weight: 600;
                    display: flex;
                    align-items: center;

                    img {
                        width: 0.08rem;
                        height: .3rem;
                        margin-right: .1rem;
                    }
                }

                .lis2,
                .lis3,
                .lis4 {
                    /** 文本1 */
                    font-size: .28rem;
                    font-weight: 400;
                    line-height: .40rem;
                    color: rgba(122, 122, 122, 1);

                    span {
                        color: rgba(73, 94, 235, 1);
                    }
                }
            }


            .li-3 {
                .lis1 {
                    display: flex;
                    align-items: center;
                    padding-top: .3rem;
                    margin-bottom: .3rem;

                    img {
                        width: 0.08rem;
                        height: .3rem;
                        margin-right: .1rem;
                    }

                    .r {
                        opacity: 1;
                        /** 文本1 */
                        font-size: .34rem;
                        font-weight: 600;
                        letter-spacing: 0px;
                        line-height: .4rem;
                        color: rgba(231, 20, 26, 1);
                    }
                }

                .lis2,
                .lis3,
                .lis4,
                .lis5 {
                    opacity: 1;
                    font-size: .28rem;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: .40rem;
                    color: rgba(122, 122, 122, 1);


                    span {
                        color: rgba(73, 94, 235, 1);
                    }

                }
            }
        }

        .h2_2 {
            background-color: rgba(248, 248, 248, 1);

            .w {
                padding-top: .2rem;

                .img1 {
                    width: 6.86rem;
                    // height: 4.62rem;
                }

                .img2 {
                    width: 6.86rem;
                    // height: 4.62rem;
                }

                .img3 {
                    width: 6.86rem;
                    // height: 9.17rem;
                }
            }
        }

        .h2_3 {
            font-size: 0;
            padding-top: .2rem;
            background-color: rgba(248, 248, 248, 1);

            img {
                width: 100%;
            }
        }

        .h2_4 {
            .lis1 {
                background-color: rgba(248, 248, 248, 1);
                padding-top: .2rem;

                .w {
                    img {
                        width: 6.86rem;
                    }

                    .text {
                        margin-top: .3rem;
                        opacity: 1;
                        font-size: .28rem;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: .4rem;
                        color: rgba(122, 122, 122, 1);

                        span {
                            font-weight: 700;
                            color: rgba(73, 94, 235, 1);
                        }

                    }
                }
            }

            .lis2 {
                width: 100%;
                background-color: #fff;

                .w {
                    .text1 {
                        padding-top: .3rem;
                        opacity: 1;
                        /** 文本1 */
                        font-size: .34rem;
                        font-weight: 600;
                        color: rgba(51, 51, 51, 1);
                        margin-bottom: .3rem;
                    }

                    .text2 {
                        margin-bottom: .38rem;
                        width: 100%;
                        opacity: 1;
                        font-size: 0.28rem;
                        font-weight: 400;
                        color: rgba(122, 122, 122, 1);
                        display: flex;
                        align-items: center;
                        justify-content: start;

                        .img1 {
                            width: 0.4rem;
                            height: .4rem;
                            margin-right: 0.15rem;
                        }

                        .img2 {
                            width: 2.69rem;
                            height: 0.24rem;
                        }

                    }
                }
            }

            .lis3 {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding-top: .3rem;
                padding-bottom: .3rem;

                img {
                    width: 1.96rem;
                    height: 1.86rem;
                    margin-bottom: .3rem;
                }

                span {
                    font-size: .28rem;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/mOfficial/index.vue